import $ from "jquery";
import "slick-carousel";
function ready() {
  $(".homepage-slider").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $(document).on("click", ".slider-prev-btn", function() {
    $(".homepage-slider").slick("slickPrev");
  });

  $(document).on("click", ".slider-next-btn", function() {
    $(".homepage-slider").slick("slickNext");
  });
}
function unslick() {
  $(".homepage-slider").slick("unslick");
}
$(document).on("turbolinks:before-cache", unslick);
$(document).on("turbolinks:load", ready);